import { useEffect } from 'react'

export function useTitle(title?: string) {
    useEffect(() => {
        const prev = document.title

        document.title = `Evaa | ${title || ''}`

        return () => {
            document.title = prev
        }
    }, [title])
}
